import Box from '@mui/material/Box';

import { RevealGroup } from '@/components/atoms';
import { IconFeature } from '@/components/molecules';
import { type ContentItem } from '@/content/site';

type Props = { items: readonly ContentItem[]; columns?: 2 | 3 | 4; inverse?: boolean };

/**
 * A flat list of differentiators, every item weighted the same. For a list
 * whose items do not carry equal weight, or whose length would orphan an item
 * on a row of its own, reach for `WhyKabexBento` instead.
 *
 * The sequence is one `RevealGroup` around the list rather than a `Reveal` per
 * cell: eight items used to mean eight IntersectionObservers, on a page that
 * renders this band up to four times, and the stagger is the same CSS either
 * way. That also makes the list a plain CSS grid, matching the two other
 * grids on the site.
 */
export function FeatureGrid({ items, columns = 3, inverse }: Props) {
  return (
    <RevealGroup
      component="ul"
      step={60}
      sx={{
        listStyle: 'none',
        p: 0,
        m: 0,
        display: 'grid',
        gap: { xs: 6, md: 8 },
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: `repeat(${columns}, 1fr)`,
        },
      }}
    >
      {items.map((item) => (
        <Box component="li" key={item.title}>
          <IconFeature item={item} {...(inverse ? { inverse } : {})} />
        </Box>
      ))}
    </RevealGroup>
  );
}
